var React = require('react');

function Question (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M19.9857 26.5H23.4308V24.1044C23.4308 23.4021 23.6298 23.2106 24.2882 23.2106H24.4107C27.7486 23.2744 30.0453 20.5451 29.9993 17.2094C30.0453 13.5065 27.3352 10.9528 23.7523 11.0007H17V14.3843H23.2011C25.0997 14.3843 26.3093 15.5016 26.3093 17.2253C26.3093 19.1406 25.1916 20.0982 23.2776 20.0982H22.4815C20.8431 20.0982 19.9857 21.008 19.9857 22.7158V26.5ZM19.7254 33H23.6451V28.9619H19.7254V33Z","fill":"black","key":1})]);
}

Question.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Question;

Question.default = Question;
